import { render, staticRenderFns } from "./CollapseIcon.vue?vue&type=template&id=fc6a1f1c&"
import script from "./CollapseIcon.vue?vue&type=script&lang=ts&"
export * from "./CollapseIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports